import { render } from "./AddEditTermsAndConditions.vue?vue&type=template&id=20d93a74"
import script from "./AddEditTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./AddEditTermsAndConditions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__